// BonBoZ: logic thuần của cuộc gọi Zalo (popup lúc reo + thẻ trong hội thoại).
// Tách khỏi .vue để test. Hai nguồn dữ liệu, một hình dạng:
//   - realtime `bonboz.cuoc_goi` (snake_case) -> chuanHoa()
//   - content_attributes `bonboz_zalo_cuoc_goi` (đã camelCase sẵn)
const P = 'BONBOZ.CUOC_GOI';

export const SU_KIEN_CUOC_GOI = 'bonboz:cuoc_goi';
/** Popup kết thúc tự đóng sau ngần này. */
export const TU_DONG_DONG_MS = 8000;
export const DUONG_CHUONG = '/audio/dashboard/ringtone.mp3';

/** Trang trong phạm vi đang xem. `ids` rỗng = tất cả (luật của useSelectedPages). */
export const trongPhamVi = (ids, inboxId) =>
  !ids?.length || ids.map(Number).includes(Number(inboxId));

/**
 * Sự kiện đáng bật popup. Chỉ cuộc gọi ĐẾN (`di` là nhân viên tự bấm gọi trên
 * điện thoại — đã biết rồi), chỉ lúc reo và lúc kết thúc, chỉ trang đang xem.
 */
export const nenHienPopup = (data, ids = []) =>
  data?.huong === 'den' &&
  (data.loai === 'dang_goi' || data.loai === 'ket_thuc') &&
  trongPhamVi(ids, data.inbox_id);

/** Payload realtime -> cùng hình dạng với thẻ, để dùng chung mọi hàm dưới đây. */
export const chuanHoa = (d = {}) => ({
  callId: d.call_id,
  trangThai: d.loai,
  huong: d.huong,
  nho: !!d.nho,
  thoiLuong: d.thoi_luong || 0,
  goiVideo: !!d.goi_video,
  inboxId: d.inbox_id,
  conversationId: d.conversation_id,
  khach: d.khach || {},
});

/** "16 giây", "1 phút 06 giây". 0/null = '' (gọi nhỡ không có thời lượng). */
export const dinhDangThoiLuong = (giay, t) => {
  const s = Math.max(0, Math.floor(Number(giay) || 0));
  if (!s) return '';
  const phut = Math.floor(s / 60);
  if (!phut) return t(`${P}.GIAY`, { so: s });
  return t(`${P}.PHUT_GIAY`, {
    phut,
    giay: String(s % 60).padStart(2, '0'),
  });
};

/** Một câu tóm tắt dùng cho cả thẻ lẫn popup kết thúc. */
export const tomTat = (the, t) => {
  if (the.trangThai === 'dang_goi')
    return t(`${P}.${the.huong === 'den' ? 'DANG_GOI_DEN' : 'DANG_GOI_DI'}`);
  if (the.trangThai === 'da_nghe') return t(`${P}.DANG_NOI`);
  if (the.nho) return t(`${P}.${the.huong === 'den' ? 'DEN_NHO' : 'DI_NHO'}`);

  const phan = [t(`${P}.KET_THUC`)];
  const thoiLuong = dinhDangThoiLuong(the.thoiLuong, t);
  if (thoiLuong) phan.push(thoiLuong);
  if (the.goiVideo) phan.push(t(`${P}.GOI_VIDEO`));
  return phan.join(' · ');
};

export const bieuTuong = (the = {}) => {
  if (the.nho) return 'i-lucide-phone-missed';
  if (the.goiVideo) return 'i-lucide-video';
  return the.huong === 'di'
    ? 'i-lucide-phone-outgoing'
    : 'i-lucide-phone-incoming';
};

/** Đỏ cho gọi nhỡ, còn lại trung tính. */
export const mauBieuTuong = (the = {}) =>
  the.nho ? 'bg-n-ruby-3 text-n-ruby-11' : 'bg-n-teal-3 text-n-teal-11';
